import React from "react";
import { Box, Grid } from "@mui/material";

import AdminSidebar from "../../../../components/Administration/AdminSidebar";
import { crmUi } from "./CrmUi";

const CrmShell = ({ children }) => (
  <Box
    sx={{
      flexGrow: 1,           
      padding: 3
    }}
  >
    <Grid container spacing={{ xs: 1.25, md: 1.5 }}>
      <Grid item xs={12} md={3} lg={2}>
        <AdminSidebar />
      </Grid>

      <Grid item xs={12} md={9} lg={10} sx={{ minWidth: 0 }}>
        <Box sx={{ maxWidth: 1440, mx: "auto" }}>{children}</Box>
      </Grid>
    </Grid>
  </Box>
);

export default CrmShell;
